import { render } from "./AddEtudiantPage.vue?vue&type=template&id=605c14fb&ts=true"
import script from "./AddEtudiantPage.vue?vue&type=script&lang=ts"
export * from "./AddEtudiantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__